import * as Yup from 'yup';

export const formSchema = Yup.object().shape({
  requireConfirmation: Yup.bool(),
  confirmation: Yup.bool().when('requireConfirmation', {
    is: true,
    then: Yup.bool()
      .oneOf([true], 'Please select agree to proceed')
      .required('Please select agree to proceed'),
  }),
});
